import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { trim } from 'ramda';

import withFormItem from './withFormItem';
import withFormikField, { formFieldPropTypes } from './withFormikField';

@withFormItem
export class InputComponent extends Component {
    static propTypes = {
        ...formFieldPropTypes,
        placeholder: PropTypes.string,
        prefix: PropTypes.node,
        type: PropTypes.string,
    };

    onChange = e => {
        this.props.onChange(e.target.value || '');
    }

    onBlur = () => this.props.onChange(trim(this.props.value || ''));

    render() {
        const { value, placeholder, prefix, htmlType } = this.props;

        return (
            <Input
                prefix={prefix}
                type={htmlType}
                value={value}
                placeholder={placeholder}
                onChange={this.onChange}
                onBlur={this.onBlur} />
        );
    }
}

export default withFormikField(InputComponent);
